import React from "react";
import AppLogoWhite from "../../../../assets/images/app-logo-white.png";
import { useNavigate } from "react-router-dom";

const InstallmentBanner = () => {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col lg:flex-row items-center lg:justify-between w-full h-full bg-[#F19D00] text-black px-6 pt-20 lg:pt-0 relative">
      {/* Nội dung trên */}
      <div className="flex-1 text-center space-y-4 lg:space-y-6">
        <div className="flex gap-2 items-end justify-center">
          <h2 className="text-2xl lg:text-5xl font-bold text-white text-nowrap whitespace-nowrap">
            Dịch vụ
          </h2>
          <h2 className="text-4xl lg:text-7xl font-bold text-white text-nowrap whitespace-nowrap">
            trả góp
          </h2>
          <h2 className="text-2xl lg:text-5xl font-bold text-white text-nowrap whitespace-nowrap">
            linh hoạt
          </h2>
        </div>
        <p className="text-sm lg:text-lg text-gray-800">
          Sở hữu sản phẩm yêu thích mà không cần trả trước toàn bộ. Đăng ký dễ
          dàng, thanh toán tiện lợi!
        </p>
        <button
          onClick={() =>
            navigate(
              "/services-offers/mua-tra-gop-linh-hoat-nhan-may-truoc-tra-sau"
            )
          }
          className="px-4 py-2 border border-black text-black rounded-md hover:bg-black hover:text-white transition"
        >
          Xem chi tiết
        </button>
      </div>

      <div className="absolute bottom-[9rem] lg:top-[2rem] left-[2rem] lg:left-[24rem] w-[30%]">
        <img
          src={
            "https://res.cloudinary.com/dyxwbtohw/image/upload/v1759227172/apple-watch_wyesmn.png"
          }
          alt="AppleWatch"
          className="w-full lg:w-72 animate-float-tilt"
        />
      </div>

      <div className="absolute bottom-[5rem] lg:-bottom-[3.75rem] right-[3rem] w-[20%]">
        <img
          src={
            "https://res.cloudinary.com/dyxwbtohw/image/upload/v1759227172/iphone-16_dsmghs.png"
          }
          alt="Iphone16"
          className="w-full lg:w-48 animate-float-tilt-slow"
        />
      </div>

      {/* Hình ảnh minh họa */}
      <div className="flex justify-center items-end w-[50%] lg:w-[25rem] h-full lg:order-first">
        <img
          src={
            "https://res.cloudinary.com/dyxwbtohw/image/upload/v1759227171/woman-shopping_h9ik8q.jpg"
          }
          alt="Dịch vụ trả góp"
          className="w-full h-auto max-h-[90%] object-contain"
        />
      </div>

      {/* Logo */}
      <div className="absolute top-6 lg:top-12 lg:right-16 flex gap-2 items-center">
        <img src={AppLogoWhite} className="w-10 h-10" alt="Logo" />
        <div className="flex flex-col gap-0.5 items-start">
          <span className="text-md lg:text-xl font-bold text-white">
            Ly iPhone
          </span>
          <span className="text-xs font-bold text-gray-100">
            253 Hùng Vương, Tam Kỳ
          </span>
        </div>
      </div>
    </div>
  );
};

export default InstallmentBanner;
